sew-ws-gsap {
    .no-overlap {
        margin-top: 0;
    }
}
